import styled from "styled-components"

export const Input = styled.input`
  padding: 14px 0 14px 42px;
  border: 1px solid #000000;
  border-radius: 10px;
  font-size: 12px;
  line-height: 150%;
  &::placeholder {
    color: #6f6f6f;
  }
`
